// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HhC9","colBig":"styles_colBig__PI_MU","colSmall":"styles_colSmall__2uiD3"};